module.exports = __webpack_public_path__ + "assets/img/3ml.a015acc9.svg";